const findWidgetId = (element) =>
	element?.closest?.('[data-widget-id]')?.dataset?.widgetId;

export default findWidgetId;
